module.exports = __webpack_public_path__ + "starta.png?1ed8c479131aee14566adef1e7481b9e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/starta.png
// module id = 144
// module chunks = 0